import { render, staticRenderFns } from "./_EditBackupTactics.vue?vue&type=template&id=a74ff9fc&scoped=true"
import script from "./_EditBackupTactics.vue?vue&type=script&lang=ts"
export * from "./_EditBackupTactics.vue?vue&type=script&lang=ts"
import style0 from "./_EditBackupTactics.vue?vue&type=style&index=0&id=a74ff9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ff9fc",
  null
  
)

export default component.exports